import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, useMediaQuery } from '@mui/material';
import { Theme } from '@mui/material/styles';

interface Props {
  description?: string;
  translationNamespace: string;
}

const CenteredDescription = ({ description, translationNamespace }: Props): JSX.Element => {
  const { t } = useTranslation(translationNamespace);
  const sm = !useMediaQuery((theme: Theme) => theme.breakpoints.up('sm'));

  return (
    <>
      {description && (
        <Typography variant={sm ? 'h6' : 'h5'} sx={{ mb: 1 }} align='center'>
          {t(description)}
        </Typography>
      )}
    </>
  );
};

export default CenteredDescription;
